import { COMING_SOON_LABEL } from '@/constants/core';
import { cn } from '@/lib/utils';

interface ComingSoonBadgeProps {
  className?: string;
  label?: string;
}

export function ComingSoonBadge({ className, label = COMING_SOON_LABEL }: ComingSoonBadgeProps) {
  return (
    <span className={cn('bg-linear-to-br from-secondary-600 to-sivarbet-primary text-black text-[8px] font-bold uppercase px-2 py-0.5 rotate-12 shadow-lg whitespace-nowrap', className)}>
      {label}
    </span>
  );
}
